import { schSiteInfluence, schSiteRating, schSiteView } from '@aloft/toolkit-shared';
import { toOpts } from '@aloft/toolkit-sui';

import { useMemo } from 'react';

import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import { getAloftAreaJSONPropertyGridField } from '../../../components/PropertyGrid/fields/utils.tsx';
import {
  PropertyGridField,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';

export const FeatureGridSiteSection = (props: PropertyGridSectionProps) => {
  const fields: PropertyGridField[] = useMemo(
    () => [
      getAloftAreaJSONPropertyGridField({
        fieldName: 'editableData.site.area',
        label: 'Site Size',
        required: true,
      }),
      {
        fieldName: 'editableData.site.influence',
        label: 'Site Influence',
        options: toOpts(schSiteInfluence.options),
        autofillSubjectValue: true,
        required: true,
      },
      {
        fieldName: 'editableData.site.influenceRating',
        label: 'Site Influence Rating',
        options: toOpts(schSiteRating.options),
        autofillSubjectValue: true,
        required: true,
      },
      {
        fieldName: 'editableData.site.view',
        label: 'View',
        options: toOpts(schSiteView.options),
        autofillSubjectValue: true,
        required: true,
      },
      {
        fieldName: 'editableData.site.viewRating',
        label: 'View Rating',
        options: toOpts(schSiteRating.options),
        autofillSubjectValue: true,
        required: true,
      },
    ],
    [],
  );

  return <PropertyGridSection {...props} title="Site" fields={fields} />;
};
